// v1 no pdf validation

// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const NomineeInfoSection = ({ nominee, clType, setNominee, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();

//   const validationSchema = Yup.object({
//     nominee_name: Yup.string().required(t('nominee.validation.nomineeNameRequired')),
//     nominee_gender: Yup.string().required(t('nominee.validation.nomineeGenderRequired')),
//     nominee_gender_specify: Yup.string().when("nominee_gender", {
//       is: "other",
//       then: (schema) => schema.required(t('nominee.validation.specifyGenderRequired')),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     rel_with_depositor: Yup.string().required(t('nominee.validation.relationWithDepositorRequired')),
//     rel_with_depositor_specify: Yup.string().when("rel_with_depositor", {
//       is: "other",
//       then: (schema) => schema.required(t('nominee.validation.specifyRelationRequired')),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_death_cert: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.deathCertRequired'))
//           .test("fileExists", t('nominee.validation.deathCertRequired'), (value) => value != null)
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_family_tree: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.familyTreeRequired'))
//           .test("fileExists", t('nominee.validation.familyTreeRequired'), (value) => value != null)
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_nomination_proof: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.nominationProofRequired'))
//           .test("fileExists", t('nominee.validation.nominationProofRequired'), (value) => value != null)
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_ekyc_doc: Yup.mixed()
//       .required(t('nominee.validation.ekycDocRequired'))
//       .test("fileExists", t('nominee.validation.ekycDocRequired'), (value) => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     nominee_pan_doc: Yup.mixed()
//       .required(t('nominee.validation.panDocRequired'))
//       .test("fileExists", t('nominee.validation.panDocRequired'), (value) => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     ekyc_doc_type: Yup.string().required(t('nominee.validation.ekycDocTypeRequired')),
//   });

//   const formik = useFormik({
//     initialValues: {
//       ...nominee,
//       clType,
//       nominee_gender: nominee.nominee_gender || "",
//       nominee_gender_specify: nominee.nominee_gender_specify || "",
//       rel_with_depositor: nominee.rel_with_depositor || "",
//       rel_with_depositor_specify: nominee.rel_with_depositor_specify || "",
//       ekyc_doc_type: nominee.ekyc_doc_type || "",
//     },
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       const mergedValues = {
//         ...values,
//         nominee_gender:
//           values.nominee_gender === "other" ? values.nominee_gender_specify : values.nominee_gender,
//         rel_with_depositor:
//           values.rel_with_depositor === "other"
//             ? values.rel_with_depositor_specify
//             : values.rel_with_depositor,
//       };
//       delete mergedValues.nominee_gender_specify;
//       delete mergedValues.rel_with_depositor_specify;

//       setNominee(mergedValues);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChangeFormik = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//           {t('nominee.heading')}
//         </Typography>

//         <Box component="form" noValidate onSubmit={formik.handleSubmit}>
//           <Stack spacing={3}>
//             <TextField
//               margin="normal"
//               label={t('nominee.nomineeName') + " *"}
//               name="nominee_name"
//               value={formik.values.nominee_name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               fullWidth
//               error={formik.touched.nominee_name && Boolean(formik.errors.nominee_name)}
//               helperText={formik.touched.nominee_name && formik.errors.nominee_name}
//             />

//             <TwoFieldRow>
//               <FormControl
//                 fullWidth
//                 margin="normal"
//                 error={formik.touched.nominee_gender && Boolean(formik.errors.nominee_gender)}
//               >
//                 <InputLabel id="nominee_gender_label">{t('nominee.nomineeGender')} *</InputLabel>
//                 <Select
//                   labelId="nominee_gender_label"
//                   id="nominee_gender"
//                   name="nominee_gender"
//                   value={formik.values.nominee_gender}
//                   label={t('nominee.nomineeGender')}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     formik.setFieldValue("nominee_gender", value);
//                     if (value !== "other") {
//                       formik.setFieldValue("nominee_gender_specify", "");
//                     }
//                   }}
//                   onBlur={formik.handleBlur}
//                 >
//                   <MenuItem value="" disabled>
//                     {t('nominee.selectGender')}
//                   </MenuItem>
//                   <MenuItem value="male">{t('nominee.genderMale')}</MenuItem>
//                   <MenuItem value="female">{t('nominee.genderFemale')}</MenuItem>
//                   <MenuItem value="other">{t('nominee.genderOther')}</MenuItem>
//                 </Select>
//                 {formik.touched.nominee_gender && formik.errors.nominee_gender && (
//                   <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                     {formik.errors.nominee_gender}
//                   </Typography>
//                 )}

//                 {formik.values.nominee_gender === "other" && (
//                   <TextField
//                     margin="normal"
//                     label={t('nominee.specifyGender') + " *"}
//                     name="nominee_gender_specify"
//                     value={formik.values.nominee_gender_specify}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={
//                       formik.touched.nominee_gender_specify &&
//                       Boolean(formik.errors.nominee_gender_specify)
//                     }
//                     helperText={
//                       formik.touched.nominee_gender_specify &&
//                       formik.errors.nominee_gender_specify
//                     }
//                   />
//                 )}
//               </FormControl>

//               <FormControl
//                 fullWidth
//                 margin="normal"
//                 error={formik.touched.rel_with_depositor && Boolean(formik.errors.rel_with_depositor)}
//               >
//                 <InputLabel id="rel_with_depositor_label">{t('nominee.relationWithDepositor')} *</InputLabel>
//                 <Select
//                   labelId="rel_with_depositor_label"
//                   id="rel_with_depositor"
//                   name="rel_with_depositor"
//                   value={formik.values.rel_with_depositor}
//                   label={t('nominee.relationWithDepositor')}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     formik.setFieldValue("rel_with_depositor", value);
//                     if (value !== "other") {
//                       formik.setFieldValue("rel_with_depositor_specify", "");
//                     }
//                   }}
//                   onBlur={formik.handleBlur}
//                 >
//                   <MenuItem value="" disabled>
//                     {t('nominee.selectRelation')}
//                   </MenuItem>
//                   <MenuItem value="spouse">{t('nominee.relationSpouse')}</MenuItem>
//                   <MenuItem value="son">{t('nominee.relationSon')}</MenuItem>
//                   <MenuItem value="daughter">{t('nominee.relationDaughter')}</MenuItem>
//                   <MenuItem value="father">{t('nominee.relationFather')}</MenuItem>
//                   <MenuItem value="mother">{t('nominee.relationMother')}</MenuItem>
//                   <MenuItem value="other">{t('nominee.relationOther')}</MenuItem>
//                 </Select>
//                 {formik.touched.rel_with_depositor && formik.errors.rel_with_depositor && (
//                   <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                     {formik.errors.rel_with_depositor}
//                   </Typography>
//                 )}

//                 {formik.values.rel_with_depositor === "other" && (
//                   <TextField
//                     margin="normal"
//                     label={t('nominee.specifyRelation') + " *"}
//                     name="rel_with_depositor_specify"
//                     value={formik.values.rel_with_depositor_specify}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={
//                       formik.touched.rel_with_depositor_specify &&
//                       Boolean(formik.errors.rel_with_depositor_specify)
//                     }
//                     helperText={
//                       formik.touched.rel_with_depositor_specify &&
//                       formik.errors.rel_with_depositor_specify
//                     }
//                   />
//                 )}
//               </FormControl>
//             </TwoFieldRow>

//             {clType !== "self" && (
//               <>
//                 <UploadWithLabel
//                   label={t('nominee.uploadDeathCert')}
//                   name="nominee_death_cert"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_death_cert")}
//                   file={formik.values.nominee_death_cert}
//                   error={formik.touched.nominee_death_cert && Boolean(formik.errors.nominee_death_cert)}
//                   helperText={formik.touched.nominee_death_cert && formik.errors.nominee_death_cert}
//                 />

//                 <UploadWithLabel
//                   label={t('nominee.uploadFamilyTree')}
//                   name="nominee_family_tree"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_family_tree")}
//                   file={formik.values.nominee_family_tree}
//                   error={formik.touched.nominee_family_tree && Boolean(formik.errors.nominee_family_tree)}
//                   helperText={formik.touched.nominee_family_tree && formik.errors.nominee_family_tree}
//                 />

//                 <UploadWithLabel
//                   label={t('nominee.uploadNominationProof')}
//                   name="nominee_nomination_proof"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_nomination_proof")}
//                   file={formik.values.nominee_nomination_proof}
//                   error={formik.touched.nominee_nomination_proof && Boolean(formik.errors.nominee_nomination_proof)}
//                   helperText={formik.touched.nominee_nomination_proof && formik.errors.nominee_nomination_proof}
//                 />
//               </>
//             )}

//             <FormControl
//               fullWidth
//               margin="normal"
//               error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)}
//               sx={selectFormControlSX}
//             >
//               <InputLabel id="ekyc_doc_type_label">{t('nominee.ekycDocType')} *</InputLabel>
//               <Select
//                 labelId="ekyc_doc_type_label"
//                 id="ekyc_doc_type"
//                 name="ekyc_doc_type"
//                 value={formik.values.ekyc_doc_type}
//                 label={t('nominee.ekycDocType')}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               >
//                 <MenuItem value="pan">PAN</MenuItem>
//                 <MenuItem value="driving_license">{t('nominee.drivingLicense')}</MenuItem>
//                 <MenuItem value="passport">{t('nominee.passport')}</MenuItem>
//               </Select>
//               {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && (
//                 <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                   {formik.errors.ekyc_doc_type}
//                 </Typography>
//               )}
//             </FormControl>

//             <UploadWithLabel
//               label={t('nominee.uploadEkcyDoc')}
//               name="nominee_ekyc_doc"
//               onChange={(e) => handleFileChangeFormik(e, "nominee_ekyc_doc")}
//               file={formik.values.nominee_ekyc_doc}
//               error={formik.touched.nominee_ekyc_doc && Boolean(formik.errors.nominee_ekyc_doc)}
//               helperText={formik.touched.nominee_ekyc_doc && formik.errors.nominee_ekyc_doc}
//             />

//             <UploadWithLabel
//               label={t('nominee.uploadPanCard')}
//               name="nominee_pan_doc"
//               onChange={(e) => handleFileChangeFormik(e, "nominee_pan_doc")}
//               file={formik.values.nominee_pan_doc}
//               error={formik.touched.nominee_pan_doc && Boolean(formik.errors.nominee_pan_doc)}
//               helperText={formik.touched.nominee_pan_doc && formik.errors.nominee_pan_doc}
//             />

//             <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 onClick={() => {
//                   if (activeTab > 0) setActiveTab(activeTab - 1);
//                 }}
//               >
//                 {t('common.back')}
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   "&.Mui-disabled": {
//                     backgroundColor: "rgba(25, 118, 210, 0.6)",
//                     color: "rgba(255, 255, 255, 0.9)",
//                     cursor: "not-allowed",
//                   },
//                 }}
//               >
//                 {t('common.next')}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default NomineeInfoSection;


// // v2 with pdf validation
// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const NomineeInfoSection = ({ nominee, clType, setNominee, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();

//   const validationSchema = Yup.object({
//     nominee_name: Yup.string().required(t('nominee.validation.nomineeNameRequired')),
//     nominee_gender: Yup.string().required(t('nominee.validation.nomineeGenderRequired')),
//     nominee_gender_specify: Yup.string().when("nominee_gender", {
//       is: "other",
//       then: (schema) => schema.required(t('nominee.validation.specifyGenderRequired')),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     rel_with_depositor: Yup.string().required(t('nominee.validation.relationWithDepositorRequired')),
//     rel_with_depositor_specify: Yup.string().when("rel_with_depositor", {
//       is: "other",
//       then: (schema) => schema.required(t('nominee.validation.specifyRelationRequired')),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_death_cert: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.deathCertRequired'))
//           .test("fileExists", t('nominee.validation.deathCertRequired'), (value) => value != null)
//           .test("fileType", "Death certificate must be PDF only", (value) => !value || value.type === "application/pdf")
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_family_tree: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.familyTreeRequired'))
//           .test("fileExists", t('nominee.validation.familyTreeRequired'), (value) => value != null)
//           .test("fileType", "Family tree must be PDF only", (value) => !value || value.type === "application/pdf")
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_nomination_proof: Yup.mixed().when("clType", {
//       is: (val) => val !== "self",
//       then: (schema) =>
//         schema
//           .required(t('nominee.validation.nominationProofRequired'))
//           .test("fileExists", t('nominee.validation.nominationProofRequired'), (value) => value != null)
//           .test("fileType", "Nomination proof must be PDF only", (value) => !value || value.type === "application/pdf")
//           .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//     nominee_ekyc_doc: Yup.mixed()
//       .required(t('nominee.validation.ekycDocRequired'))
//       .test("fileExists", t('nominee.validation.ekycDocRequired'), (value) => value != null)
//       .test("fileType", "eKYC document must be PDF only", (value) => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     nominee_pan_doc: Yup.mixed()
//       .required(t('nominee.validation.panDocRequired'))
//       .test("fileExists", t('nominee.validation.panDocRequired'), (value) => value != null)
//       .test("fileType", "PAN document must be PDF only", (value) => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     ekyc_doc_type: Yup.string().required(t('nominee.validation.ekycDocTypeRequired')),
//   });

//   const formik = useFormik({
//     initialValues: {
//       ...nominee,
//       clType,
//       nominee_gender: nominee.nominee_gender || "",
//       nominee_gender_specify: nominee.nominee_gender_specify || "",
//       rel_with_depositor: nominee.rel_with_depositor || "",
//       rel_with_depositor_specify: nominee.rel_with_depositor_specify || "",
//       ekyc_doc_type: nominee.ekyc_doc_type || "",
//     },
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       const mergedValues = {
//         ...values,
//         nominee_gender:
//           values.nominee_gender === "other" ? values.nominee_gender_specify : values.nominee_gender,
//         rel_with_depositor:
//           values.rel_with_depositor === "other"
//             ? values.rel_with_depositor_specify
//             : values.rel_with_depositor,
//       };
//       delete mergedValues.nominee_gender_specify;
//       delete mergedValues.rel_with_depositor_specify;

//       setNominee(mergedValues);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChangeFormik = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   const selectFormControlSX = {
//     minWidth: 200,
//     maxWidth: "100%",
//   };

//   const genderRelationFormControlSX = {
//     minWidth: 250,
//     maxWidth: "100%",
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//           {t('nominee.heading')}
//         </Typography>

//         <Box component="form" noValidate onSubmit={formik.handleSubmit}>
//           <Stack spacing={3}>
//             <TextField
//               margin="normal"
//               label={t('nominee.nomineeName') + " *"}
//               name="nominee_name"
//               value={formik.values.nominee_name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               fullWidth
//               error={formik.touched.nominee_name && Boolean(formik.errors.nominee_name)}
//               helperText={formik.touched.nominee_name && formik.errors.nominee_name}
//             />

//             <TwoFieldRow>
//               <FormControl
//                 fullWidth
//                 margin="normal"
//                 error={formik.touched.nominee_gender && Boolean(formik.errors.nominee_gender)}
//                 sx={genderRelationFormControlSX}
//               >
//                 <InputLabel id="nominee_gender_label">{t('nominee.nomineeGender')} *</InputLabel>
//                 <Select
//                   labelId="nominee_gender_label"
//                   id="nominee_gender"
//                   name="nominee_gender"
//                   value={formik.values.nominee_gender}
//                   label={t('nominee.nomineeGender')}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     formik.setFieldValue("nominee_gender", value);
//                     if (value !== "other") {
//                       formik.setFieldValue("nominee_gender_specify", "");
//                     }
//                   }}
//                   onBlur={formik.handleBlur}
//                 >
//                   <MenuItem value="" disabled>
//                     {t('nominee.selectGender')}
//                   </MenuItem>
//                   <MenuItem value="male">{t('nominee.genderMale')}</MenuItem>
//                   <MenuItem value="female">{t('nominee.genderFemale')}</MenuItem>
//                   <MenuItem value="other">{t('nominee.genderOther')}</MenuItem>
//                 </Select>
//                 {formik.touched.nominee_gender && formik.errors.nominee_gender && (
//                   <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                     {formik.errors.nominee_gender}
//                   </Typography>
//                 )}

//                 {formik.values.nominee_gender === "other" && (
//                   <TextField
//                     margin="normal"
//                     label={t('nominee.specifyGender') + " *"}
//                     name="nominee_gender_specify"
//                     value={formik.values.nominee_gender_specify}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={
//                       formik.touched.nominee_gender_specify &&
//                       Boolean(formik.errors.nominee_gender_specify)
//                     }
//                     helperText={
//                       formik.touched.nominee_gender_specify &&
//                       formik.errors.nominee_gender_specify
//                     }
//                   />
//                 )}
//               </FormControl>

//               <FormControl
//                 fullWidth
//                 margin="normal"
//                 error={formik.touched.rel_with_depositor && Boolean(formik.errors.rel_with_depositor)}
//                 sx={genderRelationFormControlSX}
//               >
//                 <InputLabel id="rel_with_depositor_label">{t('nominee.relationWithDepositor')} *</InputLabel>
//                 <Select
//                   labelId="rel_with_depositor_label"
//                   id="rel_with_depositor"
//                   name="rel_with_depositor"
//                   value={formik.values.rel_with_depositor}
//                   label={t('nominee.relationWithDepositor')}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     formik.setFieldValue("rel_with_depositor", value);
//                     if (value !== "other") {
//                       formik.setFieldValue("rel_with_depositor_specify", "");
//                     }
//                   }}
//                   onBlur={formik.handleBlur}
//                 >
//                   <MenuItem value="" disabled>
//                     {t('nominee.selectRelation')}
//                   </MenuItem>
//                   <MenuItem value="spouse">{t('nominee.relationSpouse')}</MenuItem>
//                   <MenuItem value="son">{t('nominee.relationSon')}</MenuItem>
//                   <MenuItem value="daughter">{t('nominee.relationDaughter')}</MenuItem>
//                   <MenuItem value="father">{t('nominee.relationFather')}</MenuItem>
//                   <MenuItem value="mother">{t('nominee.relationMother')}</MenuItem>
//                   <MenuItem value="other">{t('nominee.relationOther')}</MenuItem>
//                 </Select>
//                 {formik.touched.rel_with_depositor && formik.errors.rel_with_depositor && (
//                   <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                     {formik.errors.rel_with_depositor}
//                   </Typography>
//                 )}

//                 {formik.values.rel_with_depositor === "other" && (
//                   <TextField
//                     margin="normal"
//                     label={t('nominee.specifyRelation') + " *"}
//                     name="rel_with_depositor_specify"
//                     value={formik.values.rel_with_depositor_specify}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={
//                       formik.touched.rel_with_depositor_specify &&
//                       Boolean(formik.errors.rel_with_depositor_specify)
//                     }
//                     helperText={
//                       formik.touched.rel_with_depositor_specify &&
//                       formik.errors.rel_with_depositor_specify
//                     }
//                   />
//                 )}
//               </FormControl>
//             </TwoFieldRow>

//             {clType !== "self" && (
//               <>
//                 <UploadWithLabel
//                   label={t('nominee.uploadDeathCert')}
//                   name="nominee_death_cert"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_death_cert")}
//                   file={formik.values.nominee_death_cert}
//                   error={formik.touched.nominee_death_cert && Boolean(formik.errors.nominee_death_cert)}
//                   helperText={formik.touched.nominee_death_cert && formik.errors.nominee_death_cert}
//                 />

//                 <UploadWithLabel
//                   label={t('nominee.uploadFamilyTree')}
//                   name="nominee_family_tree"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_family_tree")}
//                   file={formik.values.nominee_family_tree}
//                   error={formik.touched.nominee_family_tree && Boolean(formik.errors.nominee_family_tree)}
//                   helperText={formik.touched.nominee_family_tree && formik.errors.nominee_family_tree}
//                 />

//                 <UploadWithLabel
//                   label={t('nominee.uploadNominationProof')}
//                   name="nominee_nomination_proof"
//                   onChange={(e) => handleFileChangeFormik(e, "nominee_nomination_proof")}
//                   file={formik.values.nominee_nomination_proof}
//                   error={formik.touched.nominee_nomination_proof && Boolean(formik.errors.nominee_nomination_proof)}
//                   helperText={formik.touched.nominee_nomination_proof && formik.errors.nominee_nomination_proof}
//                 />
//               </>
//             )}

//             <FormControl
//               fullWidth
//               margin="normal"
//               error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)}
//               sx={selectFormControlSX}
//             >
//               <InputLabel id="ekyc_doc_type_label">{t('nominee.ekycDocType')} *</InputLabel>
//               <Select
//                 labelId="ekyc_doc_type_label"
//                 id="ekyc_doc_type"
//                 name="ekyc_doc_type"
//                 value={formik.values.ekyc_doc_type}
//                 label={t('nominee.ekycDocType')}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               >
//                 <MenuItem value="pan">PAN</MenuItem>
//                 <MenuItem value="driving_license">{t('nominee.drivingLicense')}</MenuItem>
//                 <MenuItem value="passport">{t('nominee.passport')}</MenuItem>
//               </Select>
//               {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && (
//                 <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                   {formik.errors.ekyc_doc_type}
//                 </Typography>
//               )}
//             </FormControl>

//             <UploadWithLabel
//               label={t('nominee.uploadEkcyDoc')}
//               name="nominee_ekyc_doc"
//               onChange={(e) => handleFileChangeFormik(e, "nominee_ekyc_doc")}
//               file={formik.values.nominee_ekyc_doc}
//               error={formik.touched.nominee_ekyc_doc && Boolean(formik.errors.nominee_ekyc_doc)}
//               helperText={formik.touched.nominee_ekyc_doc && formik.errors.nominee_ekyc_doc}
//             />

//             <UploadWithLabel
//               label={t('nominee.uploadPanCard')}
//               name="nominee_pan_doc"
//               onChange={(e) => handleFileChangeFormik(e, "nominee_pan_doc")}
//               file={formik.values.nominee_pan_doc}
//               error={formik.touched.nominee_pan_doc && Boolean(formik.errors.nominee_pan_doc)}
//               helperText={formik.touched.nominee_pan_doc && formik.errors.nominee_pan_doc}
//             />

//             <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 onClick={() => {
//                   if (activeTab > 0) setActiveTab(activeTab - 1);
//                 }}
//               >
//                 {t('common.back')}
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   "&.Mui-disabled": {
//                     backgroundColor: "rgba(25, 118, 210, 0.6)",
//                     color: "rgba(255, 255, 255, 0.9)",
//                     cursor: "not-allowed",
//                   },
//                 }}
//               >
//                 {t('common.next')}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default NomineeInfoSection;



import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const NomineeInfoSection = ({ nominee, clType, setNominee, activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    nominee_name: Yup.string().required(t('nominee.validation.nomineeNameRequired')),
    nominee_gender: Yup.string().required(t('nominee.validation.nomineeGenderRequired')),
    nominee_gender_specify: Yup.string().when("nominee_gender", {
      is: "other",
      then: (schema) => schema.required(t('nominee.validation.specifyGenderRequired')),
      otherwise: (schema) => schema.notRequired(),
    }),
    rel_with_depositor: Yup.string().required(t('nominee.validation.relationWithDepositorRequired')),
    rel_with_depositor_specify: Yup.string().when("rel_with_depositor", {
      is: "other",
      then: (schema) => schema.required(t('nominee.validation.specifyRelationRequired')),
      otherwise: (schema) => schema.notRequired(),
    }),
    nominee_death_cert: Yup.mixed().when("clType", {
      is: (val) => val !== "self",
      then: (schema) =>
        schema
          .required(t('nominee.validation.deathCertRequired'))
          .test("fileExists", t('nominee.validation.deathCertRequired'), (value) => value != null)
          .test("fileType", "Death certificate must be PDF only", (value) => !value || value.type === "application/pdf")
          .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
      otherwise: (schema) => schema.notRequired(),
    }),
    nominee_family_tree: Yup.mixed().when("clType", {
      is: (val) => val !== "self",
      then: (schema) =>
        schema
          .required(t('nominee.validation.familyTreeRequired'))
          .test("fileExists", t('nominee.validation.familyTreeRequired'), (value) => value != null)
          .test("fileType", "Family tree must be PDF only", (value) => !value || value.type === "application/pdf")
          .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
      otherwise: (schema) => schema.notRequired(),
    }),
    nominee_nomination_proof: Yup.mixed().when("clType", {
      is: (val) => val !== "self",
      then: (schema) =>
        schema
          .required(t('nominee.validation.nominationProofRequired'))
          .test("fileExists", t('nominee.validation.nominationProofRequired'), (value) => value != null)
          .test("fileType", "Nomination proof must be PDF only", (value) => !value || value.type === "application/pdf")
          .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
      otherwise: (schema) => schema.notRequired(),
    }),
    nominee_ekyc_doc: Yup.mixed()
      .required(t('nominee.validation.ekycDocRequired'))
      .test("fileExists", t('nominee.validation.ekycDocRequired'), (value) => value != null)
      .test("fileType", "eKYC document must be PDF only", (value) => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    nominee_pan_doc: Yup.mixed()
      .required(t('nominee.validation.panDocRequired'))
      .test("fileExists", t('nominee.validation.panDocRequired'), (value) => value != null)
      .test("fileType", "PAN document must be PDF only", (value) => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    ekyc_doc_type: Yup.string().required(t('nominee.validation.ekycDocTypeRequired')),
  });

  const formik = useFormik({
    initialValues: {
      ...nominee,
      clType,
      nominee_gender: nominee.nominee_gender || "",
      nominee_gender_specify: nominee.nominee_gender_specify || "",
      rel_with_depositor: nominee.rel_with_depositor || "",
      rel_with_depositor_specify: nominee.rel_with_depositor_specify || "",
      ekyc_doc_type: nominee.ekyc_doc_type || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const mergedValues = {
        ...values,
        nominee_gender:
          values.nominee_gender === "other" ? values.nominee_gender_specify : values.nominee_gender,
        rel_with_depositor:
          values.rel_with_depositor === "other"
            ? values.rel_with_depositor_specify
            : values.rel_with_depositor,
      };
      delete mergedValues.nominee_gender_specify;
      delete mergedValues.rel_with_depositor_specify;

      setNominee(mergedValues);
      setActiveTab(activeTab + 1);
    },
  });

  const handleFileChangeFormik = (e, fieldName) => {
    const file = e.currentTarget.files[0] || null;
    formik.setFieldValue(fieldName, file);
    formik.setFieldTouched(fieldName, true);
  };

  const selectFormControlSX = {
    minWidth: 200,
    maxWidth: "100%",
  };

  const genderRelationFormControlSX = {
    minWidth: 250,
    maxWidth: "100%",
  };

  return (
    <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
          {t('nominee.heading')}
        </Typography>

        <Box component="form" noValidate onSubmit={formik.handleSubmit}>
          <Stack spacing={3}>
            <TextField
              margin="normal"
              label={t('nominee.nomineeName') + " *"}
              name="nominee_name"
              value={formik.values.nominee_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              error={formik.touched.nominee_name && Boolean(formik.errors.nominee_name)}
              helperText={formik.touched.nominee_name && formik.errors.nominee_name}
            />

            <TwoFieldRow>
              <FormControl
                fullWidth
                margin="normal"
                error={formik.touched.nominee_gender && Boolean(formik.errors.nominee_gender)}
                sx={genderRelationFormControlSX}
              >
                <InputLabel id="nominee_gender_label">{t('nominee.nomineeGender')} *</InputLabel>
                <Select
                  labelId="nominee_gender_label"
                  id="nominee_gender"
                  name="nominee_gender"
                  value={formik.values.nominee_gender}
                  label={t('nominee.nomineeGender')}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("nominee_gender", value);
                    if (value !== "other") {
                      formik.setFieldValue("nominee_gender_specify", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                >
                  <MenuItem value="" disabled>
                    {t('nominee.selectGender')}
                  </MenuItem>
                  <MenuItem value="male">{t('nominee.genderMale')}</MenuItem>
                  <MenuItem value="female">{t('nominee.genderFemale')}</MenuItem>
                  <MenuItem value="other">{t('nominee.genderOther')}</MenuItem>
                </Select>
                {formik.touched.nominee_gender && formik.errors.nominee_gender && (
                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                    {formik.errors.nominee_gender}
                  </Typography>
                )}

                {formik.values.nominee_gender === "other" && (
                  <TextField
                    margin="normal"
                    label={t('nominee.specifyGender') + " *"}
                    name="nominee_gender_specify"
                    value={formik.values.nominee_gender_specify}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    error={
                      formik.touched.nominee_gender_specify &&
                      Boolean(formik.errors.nominee_gender_specify)
                    }
                    helperText={
                      formik.touched.nominee_gender_specify &&
                      formik.errors.nominee_gender_specify
                    }
                  />
                )}
              </FormControl>

              <FormControl
                fullWidth
                margin="normal"
                error={formik.touched.rel_with_depositor && Boolean(formik.errors.rel_with_depositor)}
                sx={genderRelationFormControlSX}
              >
                <InputLabel id="rel_with_depositor_label">{t('nominee.relationWithDepositor')} *</InputLabel>
                <Select
                  labelId="rel_with_depositor_label"
                  id="rel_with_depositor"
                  name="rel_with_depositor"
                  value={formik.values.rel_with_depositor}
                  label={t('nominee.relationWithDepositor')}
                  onChange={(e) => {
                    const value = e.target.value;
                    formik.setFieldValue("rel_with_depositor", value);
                    if (value !== "other") {
                      formik.setFieldValue("rel_with_depositor_specify", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                >
                  <MenuItem value="" disabled>
                    {t('nominee.selectRelation')}
                  </MenuItem>
                  <MenuItem value="spouse">{t('nominee.relationSpouse')}</MenuItem>
                  <MenuItem value="son">{t('nominee.relationSon')}</MenuItem>
                  <MenuItem value="daughter">{t('nominee.relationDaughter')}</MenuItem>
                  <MenuItem value="father">{t('nominee.relationFather')}</MenuItem>
                  <MenuItem value="mother">{t('nominee.relationMother')}</MenuItem>
                  <MenuItem value="other">{t('nominee.relationOther')}</MenuItem>
                </Select>
                {formik.touched.rel_with_depositor && formik.errors.rel_with_depositor && (
                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                    {formik.errors.rel_with_depositor}
                  </Typography>
                )}

                {formik.values.rel_with_depositor === "other" && (
                  <TextField
                    margin="normal"
                    label={t('nominee.specifyRelation') + " *"}
                    name="rel_with_depositor_specify"
                    value={formik.values.rel_with_depositor_specify}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    error={
                      formik.touched.rel_with_depositor_specify &&
                      Boolean(formik.errors.rel_with_depositor_specify)
                    }
                    helperText={
                      formik.touched.rel_with_depositor_specify &&
                      formik.errors.rel_with_depositor_specify
                    }
                  />
                )}
              </FormControl>
            </TwoFieldRow>

            {clType !== "self" && (
              <>
                <UploadWithLabel
                  label={t('nominee.uploadDeathCert')}
                  name="nominee_death_cert"
                  onChange={(e) => handleFileChangeFormik(e, "nominee_death_cert")}
                  file={formik.values.nominee_death_cert}
                  error={formik.touched.nominee_death_cert && Boolean(formik.errors.nominee_death_cert)}
                  helperText={formik.touched.nominee_death_cert && formik.errors.nominee_death_cert}
                />
                {formik.touched.nominee_death_cert && formik.errors.nominee_death_cert && !formik.values.nominee_death_cert && (
                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                    {formik.errors.nominee_death_cert}
                  </Typography>
                )}

                <UploadWithLabel
                  label={t('nominee.uploadFamilyTree')}
                  name="nominee_family_tree"
                  onChange={(e) => handleFileChangeFormik(e, "nominee_family_tree")}
                  file={formik.values.nominee_family_tree}
                  error={formik.touched.nominee_family_tree && Boolean(formik.errors.nominee_family_tree)}
                  helperText={formik.touched.nominee_family_tree && formik.errors.nominee_family_tree}
                />
                {formik.touched.nominee_family_tree && formik.errors.nominee_family_tree && !formik.values.nominee_family_tree && (
                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                    {formik.errors.nominee_family_tree}
                  </Typography>
                )}

                <UploadWithLabel
                  label={t('nominee.uploadNominationProof')}
                  name="nominee_nomination_proof"
                  onChange={(e) => handleFileChangeFormik(e, "nominee_nomination_proof")}
                  file={formik.values.nominee_nomination_proof}
                  error={formik.touched.nominee_nomination_proof && Boolean(formik.errors.nominee_nomination_proof)}
                  helperText={formik.touched.nominee_nomination_proof && formik.errors.nominee_nomination_proof}
                />
                {formik.touched.nominee_nomination_proof && formik.errors.nominee_nomination_proof && !formik.values.nominee_nomination_proof && (
                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                    {formik.errors.nominee_nomination_proof}
                  </Typography>
                )}
              </>
            )}

            <FormControl
              fullWidth
              margin="normal"
              error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)}
              sx={selectFormControlSX}
            >
              <InputLabel id="ekyc_doc_type_label">{t('nominee.ekycDocType')} *</InputLabel>
              <Select
                labelId="ekyc_doc_type_label"
                id="ekyc_doc_type"
                name="ekyc_doc_type"
                value={formik.values.ekyc_doc_type}
                label={t('nominee.ekycDocType')}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="pan">PAN</MenuItem>
                <MenuItem value="driving_license">{t('nominee.drivingLicense')}</MenuItem>
                <MenuItem value="passport">{t('nominee.passport')}</MenuItem>
              </Select>
              {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && (
                <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                  {formik.errors.ekyc_doc_type}
                </Typography>
              )}
            </FormControl>

            <UploadWithLabel
              label={t('nominee.uploadEkcyDoc')}
              name="nominee_ekyc_doc"
              onChange={(e) => handleFileChangeFormik(e, "nominee_ekyc_doc")}
              file={formik.values.nominee_ekyc_doc}
              error={formik.touched.nominee_ekyc_doc && Boolean(formik.errors.nominee_ekyc_doc)}
              helperText={formik.touched.nominee_ekyc_doc && formik.errors.nominee_ekyc_doc}
            />
            {formik.touched.nominee_ekyc_doc && formik.errors.nominee_ekyc_doc && !formik.values.nominee_ekyc_doc && (
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.nominee_ekyc_doc}
              </Typography>
            )}

            <UploadWithLabel
              label={t('nominee.uploadPanCard')}
              name="nominee_pan_doc"
              onChange={(e) => handleFileChangeFormik(e, "nominee_pan_doc")}
              file={formik.values.nominee_pan_doc}
              error={formik.touched.nominee_pan_doc && Boolean(formik.errors.nominee_pan_doc)}
              helperText={formik.touched.nominee_pan_doc && formik.errors.nominee_pan_doc}
            />
            {formik.touched.nominee_pan_doc && formik.errors.nominee_pan_doc && !formik.values.nominee_pan_doc && (
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.nominee_pan_doc}
              </Typography>
            )}

            <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  if (activeTab > 0) setActiveTab(activeTab - 1);
                }}
              >
                {t('common.back')}
              </Button>
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(25, 118, 210, 0.6)",
                    color: "rgba(255, 255, 255, 0.9)",
                    cursor: "not-allowed",
                  },
                }}
              >
                {t('common.next')}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default NomineeInfoSection;
